
export default {
  // Home page
  "airport_rankings": "Airport Rankings",
  "recent_reviews": "Recent Reviews",
  "loading_reviews": "Loading reviews...",
  "no_reviews": "No reviews yet.",
  "share_experience": "Share Your Experience",
  "help_photographers": "Help fellow film photographers by reviewing your airport experiences",
  "add_review": "Add Review",
  // Review tabs
  "all_reviews": "All Reviews",
  "verified_reviews": "Verified Reviews",
  "no_verified_reviews": "No verified reviews yet.",
  "creative_reviews": "Creative Reviews",
  "traveler_reviews": "Traveler Reviews",
  "no_creative_reviews": "No reviews from verified creatives yet.",
  "no_traveler_reviews": "No reviews from verified travelers yet."
};
